import { Role } from './../../../identite/shared/classes/role';

export class LotProprietaire {

    lpt_id: string;
    lpt_role_id: string;
    lpt_lot_id: string;
    lpt_date_debut: string;
    lpt_date_fin: string;
    lpt_principal: boolean;
    proprietaire: Role;


    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.lpt_id         = data['lpt_id'] ? data['lpt_id'] : null;
        this.lpt_role_id    = data['lpt_role_id'] ? data['lpt_role_id'] : null;
        this.lpt_lot_id     = data['lpt_lot_id'] ? data['lpt_lot_id'] : null;
        this.lpt_date_debut = data['lpt_date_debut'] ? data['lpt_date_debut'] : null;
        this.lpt_date_fin   = data['lpt_date_fin'] ? data['lpt_date_fin'] : null;
        this.lpt_principal  = data['lpt_principal'] === '1' || data['lpt_principal'] === true ? true : false;

        this.proprietaire   = new Role(data['proprietaire'] ? data['proprietaire'] : null);
    }
}
